import { showToast } from 'vant'

// 统一message
// eslint-disable-next-line no-unused-vars
const customMessage = async ({ msg = '', type = 'success', tipsCode = '' }) => {
  if (!msg) return null
  showToast({
    message: msg,
    type,
    forbidClick: true, // 禁止背景点击
  })
}

// 消息提示
const Tips = {
  success(opt = {}) {
    customMessage({ type: 'success', ...opt })
  },
  error(opt = {}) {
    if (!opt.msg) return null
    showToast({
      message: opt.msg,
      forbidClick: true, // 禁止背景点击
    })
  },
}

export default Tips
